import axios from "axios";

// const rootUrl = "http://ec2-3-108-60-253.ap-south-1.compute.amazonaws.com:3001/v1/";
const rootUrl = "https://repairs.incosa.io/v1/";

const otpReqUrl = rootUrl + "user/reset-password";
const updatePassUrl = rootUrl + "user/reset-password";

export const reqPasswordOtp = (email) => {
  return new Promise(async (resolve, reject) => {
    try {
      const { data } = await axios.post(otpReqUrl, { email });

      console.log(data);
      resolve(data);
    } catch (error) {
      reject(error);
    }
  });
};

export const updateUserPassword = (passObj) => {
  return new Promise(async (resolve, reject) => {
    try {
      const { data } = await axios.patch(updatePassUrl, passObj);

      console.log(data);
      resolve(data);
    } catch (error) {
      reject(error);
    }
  });
};
